import { PaymentMethodType } from '@features/invoicingSettings/enums/paymentMethodType'

import type { DisplayedPaymentMethods } from '../types/invoiceForm/displayedPaymentMethods'

// Maps a payment method stored on a document to the form field that controls its display.
//
// Only covers the methods that live in the document's `paymentMeans`. Two groups are absent by
// design: types the editor has no toggle for (BBAN, SWISH, ...), and `stripeCardPayment`, which is
// not a payment mean at all - it mirrors the organization-wide PayNow status instead of anything
// stored on the document.
export const paymentMethodTypeToFormField: Partial<Record<PaymentMethodType, keyof DisplayedPaymentMethods>> = {
  [PaymentMethodType.IBAN]: 'bank',
  [PaymentMethodType.OTHER]: 'offlinePayment',
  [PaymentMethodType.PAYPAL]: 'paypal',
}
